export const actions = {
  setClientClaims({ commit }, payload) {
    commit("SET_CLIENT_CLAIMS", payload);
  },
  setDataType({ commit }, payload) {
    commit("SET_DATA_TYPE", payload);
  },
};
